"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Subtitle = _interopRequireDefault(require("../components/common/Subtitle"));
var _ReviewedDocumentContext = require("../context/ReviewedDocumentContext");
var _rules = require("../utils/rules");
var _Errors = _interopRequireDefault(require("../components/rule-details/Errors"));
var _IssueList = _interopRequireDefault(require("@common/components/issues/IssueList"));
var _normalizeIssue = require("@common/utils/normalizeIssue");
var _ContentContainer = _interopRequireDefault(require("../components/rule-details/ContentContainer"));
var _RuleDetailsContent = _interopRequireDefault(require("../components/rule-details/RuleDetailsContent"));
var _IssueDetailHeader = _interopRequireDefault(require("@common/components/review/IssueDetailHeader"));
var _IssueActionBar = _interopRequireDefault(require("@common/components/review/IssueActionBar"));
var _ParagraphView = _interopRequireDefault(require("../components/rule-details/ParagraphView"));
var _IssueDescription = _interopRequireDefault(require("@common/components/issues/IssueDescription"));
var _IssueReasoning = _interopRequireWildcard(require("@common/components/issues/IssueReasoning"));
var _document = require("../utils/document");
var _useApplyRedline = require("../hooks/use-apply-redline");
var _dialog = require("@design/ui/dialog");
var _FeedbackForm = _interopRequireDefault(require("../components/rule-details/FeedbackForm"));
var _AuthContext = require("../context/AuthContext");
var _constants = require("../constants");
var _WordDocumentContext = require("../context/WordDocumentContext");
var _RedlineSection = _interopRequireDefault(require("../components/redline/RedlineSection"));
var _CommentSection = _interopRequireDefault(require("../components/redline/CommentSection"));
var _Pagination = _interopRequireDefault(require("@common/components/common/Pagination"));
var _RemedySectionHeader = _interopRequireDefault(require("@common/components/remedy/RemedySectionHeader"));
var _Loader = _interopRequireDefault(require("@common/components/common/Loader"));
var _PageContext = require("../context/PageContext");
var _AnalyticsContext = require("../context/AnalyticsContext");
var _useRuleFeedback2 = require("./hooks/use-rule-feedback");
var _useActionNavigation2 = require("./hooks/use-action-navigation");
var _useRuleSelection2 = require("./hooks/use-rule-selection");
var _useActionPlan2 = require("./hooks/use-action-plan");
var _RuleDetailsPage = require("./RuleDetailsPage.styles");
var _ruleActionPlan = require("./hooks/rule-action-plan");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var RuleDetailsPage = function RuleDetailsPage() {
  var _selectedRule$change_, _selectedRule$detecti, _changeDetectionRepor, _selectedRule$rule$na;
  var _useReviewedDocument = (0, _ReviewedDocumentContext.useReviewedDocument)(),
    reviewReport = _useReviewedDocument.reviewReport,
    selectedRuleUuid = _useReviewedDocument.selectedRuleUuid,
    setSelectedRuleUuid = _useReviewedDocument.setSelectedRuleUuid,
    getRuleBookmarkNames = _useReviewedDocument.getRuleBookmarkNames,
    getRuleTrackedChanges = _useReviewedDocument.getRuleTrackedChanges,
    updateActionApplied = _useReviewedDocument.updateActionApplied,
    updateActionRecoveryWarning = _useReviewedDocument.updateActionRecoveryWarning,
    updateActionOoxml = _useReviewedDocument.updateActionOoxml,
    updateActionTexts = _useReviewedDocument.updateActionTexts,
    respondedRules = _useReviewedDocument.respondedRules,
    addRespondedRule = _useReviewedDocument.addRespondedRule,
    removeRespondedRule = _useReviewedDocument.removeRespondedRule,
    concededRules = _useReviewedDocument.concededRules,
    addConcededRule = _useReviewedDocument.addConcededRule,
    removeConcededRule = _useReviewedDocument.removeConcededRule,
    currentReviewId = _useReviewedDocument.currentReviewId,
    playbooks = _useReviewedDocument.playbooks,
    ruleSectionOrder = _useReviewedDocument.ruleSectionOrder;
  var _useAnalytics = (0, _AnalyticsContext.useAnalytics)(),
    sendError = _useAnalytics.sendError;
  var authHeader = (0, _AuthContext.useAuthHeader)();
  var applyRedline = (0, _useApplyRedline.useApplyRedline)();
  var _usePage = (0, _PageContext.usePage)(),
    showPage = _usePage.showPage;
  var _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    paragraphs = _useState2[0],
    setParagraphs = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isParagraphsLoading = _useState4[0],
    setIsParagraphsLoading = _useState4[1];
  var _useState5 = (0, _react.useState)("Preferred"),
    _useState6 = _slicedToArray(_useState5, 2),
    selectedTabOption = _useState6[0],
    setSelectedTabOption = _useState6[1];
  var _useState7 = (0, _react.useState)(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isApplyingAll = _useState8[0],
    setIsApplyingAll = _useState8[1];
  var _useState9 = (0, _react.useState)(false),
    _useState0 = _slicedToArray(_useState9, 2),
    isConceding = _useState0[0],
    setIsConceding = _useState0[1];
  var _useRuleSelection = (0, _useRuleSelection2.useRuleSelection)({
      reviewReport: reviewReport,
      ruleSectionOrder: ruleSectionOrder,
      selectedRuleUuid: selectedRuleUuid,
      removeRespondedRule: removeRespondedRule,
      setSelectedRuleUuid: setSelectedRuleUuid,
      showPage: showPage,
      setIsConceding: setIsConceding,
      removeConcededRule: removeConcededRule,
      addConcededRule: addConcededRule,
      setIsParagraphsLoading: setIsParagraphsLoading,
      setParagraphs: setParagraphs,
      playbooks: playbooks,
      addRespondedRule: addRespondedRule,
      sendError: sendError,
      getRuleTrackedChanges: getRuleTrackedChanges,
      getRuleBookmarkNames: getRuleBookmarkNames,
      concededRules: concededRules,
      setIsApplyingAll: setIsApplyingAll,
      applyRedline: applyRedline,
      updateActionRecoveryWarning: updateActionRecoveryWarning,
      updateActionApplied: updateActionApplied,
      selectedTabOption: selectedTabOption,
      respondedRules: respondedRules
    }),
    selectedRule = _useRuleSelection.selectedRule,
    otherRuleIndicesFromSelection = _useRuleSelection.otherRuleIndicesFromSelection,
    bookmark = _useRuleSelection.bookmark,
    isBookmarkAnalysisLoading = _useRuleSelection.isBookmarkAnalysisLoading,
    isDocumentReviewed = _useRuleSelection.isDocumentReviewed,
    handleSelectedParagraphChange = _useRuleSelection.handleSelectedParagraphChange,
    getPreviousRuleUuid = _useRuleSelection.getPreviousRuleUuid,
    getNextRuleUuid = _useRuleSelection.getNextRuleUuid,
    handleEditRule = _useRuleSelection.handleEditRule,
    handleToggleResponded = _useRuleSelection.handleToggleResponded,
    handleToggleConceded = _useRuleSelection.handleToggleConceded,
    setIsDocumentReviewed = _useRuleSelection.setIsDocumentReviewed,
    changeDetectionReport = _useRuleSelection.changeDetectionReport,
    paragraphViewMode = _useRuleSelection.paragraphViewMode,
    isRuleConceded = _useRuleSelection.isRuleConceded,
    handleActionApplied = _useRuleSelection.handleActionApplied,
    currentActionPlan = _useRuleSelection.currentActionPlan,
    tabOptions = _useRuleSelection.tabOptions,
    isRuleResponded = _useRuleSelection.isRuleResponded;
  var reasoningText = (selectedRule === null || selectedRule === void 0 || (_selectedRule$change_ = selectedRule["change_detection_report"]) === null || _selectedRule$change_ === void 0 ? void 0 : _selectedRule$change_["explanation"]) || (selectedRule === null || selectedRule === void 0 || (_selectedRule$detecti = selectedRule["detection_report"]) === null || _selectedRule$detecti === void 0 ? void 0 : _selectedRule$detecti["explanation"]) || null;
  var actionPlans = selectedRule ? (0, _rules.getAllActionPlans)(selectedRule) : [];
  var _useRuleFeedback = (0, _useRuleFeedback2.useRuleFeedback)({
      selectedRule: selectedRule,
      currentReviewId: currentReviewId,
      authHeader: authHeader,
      selectedRuleUuid: selectedRuleUuid
    }),
    showFeedback = _useRuleFeedback.showFeedback,
    feedbackItem = _useRuleFeedback.feedbackItem,
    submitFeedback = _useRuleFeedback.submitFeedback,
    removeFeedback = _useRuleFeedback.removeFeedback,
    setShowFeedback = _useRuleFeedback.setShowFeedback;
  var matchingChangesLength = (changeDetectionReport === null || changeDetectionReport === void 0 || (_changeDetectionRepor = changeDetectionReport["matching_changes"]) === null || _changeDetectionRepor === void 0 ? void 0 : _changeDetectionRepor.length) || 0;
  var _useWordDocument = (0, _WordDocumentContext.useWordDocument)(),
    selectBookmarksRange = _useWordDocument.selectBookmarksRange;
  var _useActionNavigation = (0, _useActionNavigation2.useActionNavigation)({
      selectedRuleUuid: selectedRuleUuid,
      currentActionPlan: currentActionPlan,
      authHeader: authHeader,
      currentReviewId: currentReviewId,
      selectedRule: selectedRule,
      updateActionTexts: updateActionTexts,
      updateActionOoxml: updateActionOoxml,
      setParagraphs: setParagraphs,
      setIsParagraphsLoading: setIsParagraphsLoading,
      sendError: sendError
    }),
    currentActionIndex = _useActionNavigation.currentActionIndex,
    currentStepIndex = _useActionNavigation.currentStepIndex,
    currentCommentActionIndex = _useActionNavigation.currentCommentActionIndex,
    currentCommentStepIndex = _useActionNavigation.currentCommentStepIndex,
    isRegenerating = _useActionNavigation.isRegenerating,
    showFeedbackForm = _useActionNavigation.showFeedbackForm,
    handlePrevRedlineStep = _useActionNavigation.handlePrevRedlineStep,
    handleNextRedlineStep = _useActionNavigation.handleNextRedlineStep,
    handleRegenerateCallback = _useActionNavigation.handleRegenerateCallback,
    handleToggleFeedbackCallback = _useActionNavigation.handleToggleFeedbackCallback,
    setCurrentCommentActionIndex = _useActionNavigation.setCurrentCommentActionIndex,
    setCurrentCommentStepIndex = _useActionNavigation.setCurrentCommentStepIndex,
    resetNavigationIndices = _useActionNavigation.resetNavigationIndices;
  var _useActionPlan = (0, _useActionPlan2.useActionPlan)({
      selectedRuleUuid: selectedRuleUuid,
      selectBookmarksRange: selectBookmarksRange,
      currentCommentActionIndex: currentCommentActionIndex,
      currentCommentStepIndex: currentCommentStepIndex,
      currentActionIndex: currentActionIndex,
      currentStepIndex: currentStepIndex,
      selectedRule: selectedRule,
      handleActionApplied: handleActionApplied,
      currentActionPlan: currentActionPlan,
      tabOptions: tabOptions,
      selectedTabOption: selectedTabOption,
      setSelectedTabOption: setSelectedTabOption
    }),
    redlineOoxmls = _useActionPlan.redlineOoxmls,
    redlineBookmarks = _useActionPlan.redlineBookmarks,
    redlineTargetOoxmlBefores = _useActionPlan.redlineTargetOoxmlBefores,
    redlineTextRedline = _useActionPlan.redlineTextRedline,
    handleCommentActionApplied = _useActionPlan.handleCommentActionApplied,
    handleGoToIssue = _useActionPlan.handleGoToIssue;
  (0, _react.useEffect)(function () {
    var checkDocumentReviewStatus = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var reviewStatus, isReviewed;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return (0, _document.fetchPropertyFromDocComments)(_constants.DIOPTRA_DOCUMENT_REVIEWED);
            case 1:
              reviewStatus = _context.v;
              isReviewed = reviewStatus === "true";
              setIsDocumentReviewed(isReviewed);
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function checkDocumentReviewStatus() {
        return _ref.apply(this, arguments);
      };
    }();
    checkDocumentReviewStatus();
  }, [setIsDocumentReviewed]);
  var hasUserPlaybookBehindReview = function hasUserPlaybookBehindReview(reviewPlaybooks) {
    var _reviewPlaybooks$leng;
    return ((_reviewPlaybooks$leng = reviewPlaybooks === null || reviewPlaybooks === void 0 ? void 0 : reviewPlaybooks.length) !== null && _reviewPlaybooks$leng !== void 0 ? _reviewPlaybooks$leng : 0) > 0;
  };
  var canEditRule = hasUserPlaybookBehindReview(playbooks);
  if (!selectedRule) {
    return "Loading rule...";
  }
  var hasActionPlanWithContent = currentActionPlan && currentActionPlan.length > 0;
  var conditionalContent = null;
  if (!isDocumentReviewed && (selectedRule.detection_report.rule_match || hasActionPlanWithContent)) {
    if (selectedRule.rule.status === "REMEDY") {
      conditionalContent = /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        style: {
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '200px',
          marginTop: '40px'
        },
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Loader.default, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          style: {
            marginTop: '16px',
            fontSize: '14px',
            color: '#666',
            textAlign: 'center'
          },
          children: "Computing the Remedy..."
        })]
      });
    } else {
      var _latestRule$alternati;
      var latestRule = (reviewReport === null || reviewReport === void 0 ? void 0 : reviewReport.find(function (r) {
        return r.rule.uuid === selectedRuleUuid;
      })) || selectedRule;
      var selectedIndex = tabOptions.indexOf(selectedTabOption);
      var latestActionPlan = selectedIndex === 0 || selectedIndex === -1 ? latestRule.action_plan : ((_latestRule$alternati = latestRule.alternative_action_plans) === null || _latestRule$alternati === void 0 ? void 0 : _latestRule$alternati[selectedIndex - 1]) || latestRule.action_plan;
      if (latestActionPlan && latestActionPlan.length > 0) {
        var _latestRule$action_pl, _latestRule$action_pl2, _latestRule$action_pl3;
        var _getValidRedlineActio = (0, _ruleActionPlan.getValidRedlineActionsAndSteps)(latestActionPlan),
          validRedlineActions = _getValidRedlineActio.validActions,
          validRedlineStepsMap = _getValidRedlineActio.validStepsMap;
        var _getValidCommentActio = (0, _ruleActionPlan.getValidCommentActionsAndSteps)(latestActionPlan),
          validCommentActions = _getValidCommentActio.validActions,
          validCommentStepsMap = _getValidCommentActio.validStepsMap;
        var currentRedlineAction = validRedlineActions[Math.min(currentActionIndex, validRedlineActions.length - 1)];
        var validRedlineSteps = validRedlineStepsMap.get(currentRedlineAction) || [];
        var currentRedlineStep = validRedlineSteps[Math.min(currentStepIndex, validRedlineSteps.length - 1)];
        var originalRedlineActionIndex = (0, _ruleActionPlan.getOriginalActionIndex)(currentActionIndex, validRedlineActions, latestActionPlan);
        var originalRedlineStepIndex = currentRedlineStep ? (0, _ruleActionPlan.getOriginalStepIndex)(currentStepIndex, validRedlineSteps, currentRedlineAction) : -1;
        var currentCommentAction = validCommentActions[Math.min(currentCommentActionIndex, validCommentActions.length - 1)];
        var validCommentSteps = validCommentStepsMap.get(currentCommentAction) || [];
        var currentCommentStep = validCommentSteps[Math.min(currentCommentStepIndex, validCommentSteps.length - 1)];
        var originalCommentActionIndex = (0, _ruleActionPlan.getOriginalActionIndex)(currentCommentActionIndex, validCommentActions, latestActionPlan);
        var originalCommentStepIndex = currentCommentStep ? (0, _ruleActionPlan.getOriginalStepIndex)(currentCommentStepIndex, validCommentSteps, currentCommentAction) : -1;
        var totalRedlineActions = validRedlineActions.length;
        var totalCommentActions = validCommentActions.length;
        var totalCommentSteps = validCommentSteps.length;
        var globalRedlineStepIndex = 0;
        var totalGlobalRedlineSteps = 0;
        for (var i = 0; i < currentActionIndex; i++) {
          var action = validRedlineActions[i];
          var steps = validRedlineStepsMap.get(action) || [];
          globalRedlineStepIndex += steps.length;
        }
        globalRedlineStepIndex += currentStepIndex;
        var _iterator = _createForOfIteratorHelper(validRedlineActions),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _action = _step.value;
            var _steps = validRedlineStepsMap.get(_action) || [];
            totalGlobalRedlineSteps += _steps.length;
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        var handlePrevCommentAction = function handlePrevCommentAction() {
          if (currentCommentActionIndex > 0) {
            setCurrentCommentActionIndex(currentCommentActionIndex - 1);
            setCurrentCommentStepIndex(_useActionNavigation2.DEFAULT_CURRENT_COMMENT_STEP_INDEX);
          }
        };
        var handleNextCommentAction = function handleNextCommentAction() {
          if (currentCommentActionIndex < totalCommentActions - 1) {
            setCurrentCommentActionIndex(currentCommentActionIndex + 1);
            setCurrentCommentStepIndex(_useActionNavigation2.DEFAULT_CURRENT_COMMENT_STEP_INDEX);
          }
        };
        var handlePrevCommentStep = function handlePrevCommentStep() {
          if (currentCommentStepIndex > 0) {
            setCurrentCommentStepIndex(currentCommentStepIndex - 1);
          } else if (currentCommentActionIndex > 0) {
            var prevAction = validCommentActions[currentCommentActionIndex - 1];
            var prevSteps = validCommentStepsMap.get(prevAction) || [];
            setCurrentCommentActionIndex(currentCommentActionIndex - 1);
            setCurrentCommentStepIndex(prevSteps.length - 1);
          }
        };
        var handleNextCommentStep = function handleNextCommentStep() {
          if (currentCommentStepIndex < totalCommentSteps - 1) {
            setCurrentCommentStepIndex(currentCommentStepIndex + 1);
          } else if (currentCommentActionIndex < totalCommentActions - 1) {
            setCurrentCommentActionIndex(currentCommentActionIndex + 1);
            setCurrentCommentStepIndex(_useActionNavigation2.DEFAULT_CURRENT_COMMENT_STEP_INDEX);
          }
        };
        conditionalContent = /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          children: [totalRedlineActions > 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            style: {
              marginBottom: totalCommentActions > 0 ? "16px" : "60px"
            },
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_RemedySectionHeader.default, {
              kind: "redlines",
              variants: tabOptions,
              selectedVariantId: selectedTabOption,
              onVariantSelect: function onVariantSelect(option) {
                setSelectedTabOption(option);
                resetNavigationIndices();
              },
              onGoToIssue: function onGoToIssue() {
                var _currentRedlineStep$a;
                return handleGoToIssue(currentRedlineStep === null || currentRedlineStep === void 0 || (_currentRedlineStep$a = currentRedlineStep.action_report) === null || _currentRedlineStep$a === void 0 ? void 0 : _currentRedlineStep$a.target_bookmark_names);
              }
            }), currentRedlineStep && /*#__PURE__*/(0, _jsxRuntime.jsx)(_RedlineSection.default, {
              ooxmls: redlineOoxmls,
              textRedline: redlineTextRedline,
              cardComments: [],
              actionId: null,
              bookmarks: redlineBookmarks,
              target_ooxml_befores: redlineTargetOoxmlBefores,
              onRegenerate: handleRegenerateCallback,
              isRegenerating: isRegenerating === currentActionIndex,
              showFeedbackForm: showFeedbackForm === currentActionIndex,
              onToggleFeedback: handleToggleFeedbackCallback,
              isActionApplied: originalRedlineActionIndex >= 0 && originalRedlineStepIndex >= 0 && ((_latestRule$action_pl = latestRule.action_plan) === null || _latestRule$action_pl === void 0 || (_latestRule$action_pl = _latestRule$action_pl[originalRedlineActionIndex]) === null || _latestRule$action_pl === void 0 || (_latestRule$action_pl = _latestRule$action_pl.steps) === null || _latestRule$action_pl === void 0 || (_latestRule$action_pl = _latestRule$action_pl[originalRedlineStepIndex]) === null || _latestRule$action_pl === void 0 ? void 0 : _latestRule$action_pl.action_applied),
              onActionApplied: function onActionApplied() {
                return handleActionApplied(originalRedlineActionIndex, originalRedlineStepIndex);
              },
              onGoToIssue: function onGoToIssue() {
                var _currentRedlineStep$a2;
                return handleGoToIssue((_currentRedlineStep$a2 = currentRedlineStep.action_report) === null || _currentRedlineStep$a2 === void 0 ? void 0 : _currentRedlineStep$a2.target_bookmark_names);
              },
              onPrevStep: handlePrevRedlineStep,
              onNextStep: handleNextRedlineStep,
              currentStepIndex: globalRedlineStepIndex,
              totalSteps: totalGlobalRedlineSteps,
              recoveryWarning: originalRedlineActionIndex >= 0 && originalRedlineStepIndex >= 0 ? (_latestRule$action_pl2 = (_latestRule$action_pl3 = latestRule.action_plan) === null || _latestRule$action_pl3 === void 0 || (_latestRule$action_pl3 = _latestRule$action_pl3[originalRedlineActionIndex]) === null || _latestRule$action_pl3 === void 0 || (_latestRule$action_pl3 = _latestRule$action_pl3.steps) === null || _latestRule$action_pl3 === void 0 || (_latestRule$action_pl3 = _latestRule$action_pl3[originalRedlineStepIndex]) === null || _latestRule$action_pl3 === void 0 ? void 0 : _latestRule$action_pl3.recovery_warning) !== null && _latestRule$action_pl2 !== void 0 ? _latestRule$action_pl2 : undefined : undefined,
              onRecoveryWarning: function onRecoveryWarning(warning) {
                if (originalRedlineActionIndex >= 0 && originalRedlineStepIndex >= 0) {
                  updateActionRecoveryWarning(latestRule.rule.uuid, originalRedlineActionIndex, originalRedlineStepIndex, warning);
                }
              }
            })]
          }), totalCommentActions > 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            style: {
              marginBottom: "60px"
            },
            children: [totalRedlineActions === 0 ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_RemedySectionHeader.default, {
              kind: "comments",
              variants: tabOptions,
              selectedVariantId: selectedTabOption,
              onVariantSelect: function onVariantSelect(option) {
                setSelectedTabOption(option);
                resetNavigationIndices();
              },
              onGoToIssue: function onGoToIssue() {
                var _currentCommentStep$a;
                return handleGoToIssue(currentCommentStep === null || currentCommentStep === void 0 || (_currentCommentStep$a = currentCommentStep.action_report) === null || _currentCommentStep$a === void 0 ? void 0 : _currentCommentStep$a.target_bookmark_names);
              }
            }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_RuleDetailsPage.CommentHeader, {
              children: "Comment"
            }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
              style: {
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '0'
              },
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Pagination.default, {
                currentIndex: currentCommentActionIndex,
                totalItems: totalCommentActions,
                onPrev: handlePrevCommentAction,
                onNext: handleNextCommentAction,
                label: "Comment Action"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Pagination.default, {
                currentIndex: currentCommentStepIndex,
                totalItems: totalCommentSteps,
                onPrev: handlePrevCommentStep,
                onNext: handleNextCommentStep,
                label: "Comment Step"
              })]
            }), currentCommentStep && currentCommentStep.action_report.action_tracked_changes && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              children: currentCommentStep.action_report.action_tracked_changes.filter(function (change) {
                return change.tag === 'comment';
              }).map(function (comment, index) {
                var _currentCommentStep$a2, _currentCommentStep$a3, _latestActionPlan$ori;
                return /*#__PURE__*/(0, _jsxRuntime.jsx)(_CommentSection.default, {
                  comment: comment,
                  bookmarks: currentCommentStep.action_report.target_bookmark_names || [],
                  placement: (_currentCommentStep$a2 = currentCommentStep.action_report.comment_placement) !== null && _currentCommentStep$a2 !== void 0 ? _currentCommentStep$a2 : null,
                  anchorText: currentCommentStep.action_report.comment_placement === "span" ? (_currentCommentStep$a3 = currentCommentStep.anchor_text) !== null && _currentCommentStep$a3 !== void 0 ? _currentCommentStep$a3 : null : null,
                  onGoToIssue: function onGoToIssue() {
                    return handleGoToIssue(currentCommentStep.action_report.target_bookmark_names);
                  },
                  isActionApplied: originalCommentActionIndex >= 0 && originalCommentStepIndex >= 0 && (latestActionPlan === null || latestActionPlan === void 0 || (_latestActionPlan$ori = latestActionPlan[originalCommentActionIndex]) === null || _latestActionPlan$ori === void 0 || (_latestActionPlan$ori = _latestActionPlan$ori.steps) === null || _latestActionPlan$ori === void 0 || (_latestActionPlan$ori = _latestActionPlan$ori[originalCommentStepIndex]) === null || _latestActionPlan$ori === void 0 ? void 0 : _latestActionPlan$ori.action_applied),
                  onActionApplied: handleCommentActionApplied
                }, "".concat(comment.id, "-").concat(index));
              })
            })]
          })]
        });
      }
    }
  } else if (paragraphs) {
    conditionalContent = /*#__PURE__*/(0, _jsxRuntime.jsx)(_ParagraphView.default, {
      mode: paragraphViewMode,
      paragraphs: paragraphs,
      onSelectedParagraphChange: handleSelectedParagraphChange,
      isLoading: isParagraphsLoading
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_ContentContainer.default, {
    className: "p-1",
    "data-sentry-element": "ContentContainer",
    "data-sentry-component": "RuleDetailsPage",
    "data-sentry-source-file": "RuleDetailsPage.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_IssueDetailHeader.default, {
      title: (_selectedRule$rule$na = selectedRule === null || selectedRule === void 0 ? void 0 : selectedRule.rule.name) !== null && _selectedRule$rule$na !== void 0 ? _selectedRule$rule$na : "",
      onBack: function onBack() {
        setSelectedRuleUuid(null);
        showPage(_PageContext.PAGES.documentReviewPage);
      },
      onEdit: canEditRule ? handleEditRule : undefined,
      "data-sentry-element": "IssueDetailHeader",
      "data-sentry-source-file": "RuleDetailsPage.tsx"
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_RuleDetailsContent.default, {
      "data-sentry-element": "RuleDetailsContent",
      "data-sentry-source-file": "RuleDetailsPage.tsx",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "flex flex-col gap-1 pb-4",
        children: [selectedRule && /*#__PURE__*/(0, _jsxRuntime.jsx)(_IssueDescription.default, {
          text: selectedRule.rule.description
        }), reasoningText && /*#__PURE__*/(0, _jsxRuntime.jsx)(_IssueReasoning.default, {
          text: reasoningText,
          outcome: (0, _IssueReasoning.reasoningOutcomeOf)(!!selectedRule.detection_report.rule_match, (0, _normalizeIssue.statusToStage)((0, _normalizeIssue.resolveStatus)(selectedRule)))
        })]
      }), conditionalContent, matchingChangesLength > 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        children: [matchingChangesLength, " matching change", matchingChangesLength > 1 ? "s" : "", " ", /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          style: {
            backgroundColor: "#B9C9E7BD"
          },
          children: "highlighted above"
        }), ":"]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Errors.default, {
        actionPlans: actionPlans,
        "data-sentry-element": "Errors",
        "data-sentry-source-file": "RuleDetailsPage.tsx"
      }), bookmark && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        style: {
          marginTop: "20px"
        },
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Subtitle.default, {
          children: "Applied rules in this section:"
        }), isBookmarkAnalysisLoading ? /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
          children: "Loading..."
        }) : otherRuleIndicesFromSelection.length > 0 ? function () {
          var relatedIssues = (0, _normalizeIssue.reviewReportToNormalizedIssues)(otherRuleIndicesFromSelection.map(function (uuid, idx) {
            var rule = reviewReport.find(function (r) {
              return r.rule.uuid === uuid;
            });
            return rule ? _objectSpread(_objectSpread({}, rule), {}, {
              index: idx
            }) : null;
          }).filter(function (r) {
            return r !== null;
          }));
          return /*#__PURE__*/(0, _jsxRuntime.jsx)(_IssueList.default, {
            items: relatedIssues,
            onItemClick: function onItemClick(index) {
              var _relatedIssues$index$, _relatedIssues$index;
              setSelectedRuleUuid((_relatedIssues$index$ = (_relatedIssues$index = relatedIssues[index]) === null || _relatedIssues$index === void 0 ? void 0 : _relatedIssues$index.ruleUuid) !== null && _relatedIssues$index$ !== void 0 ? _relatedIssues$index$ : null);
            }
          });
        }() : /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
          style: {
            color: "#666"
          },
          children: "No other rules applied here"
        })]
      })]
    }), selectedRule && /*#__PURE__*/(0, _jsxRuntime.jsx)(_IssueActionBar.default, {
      onPrev: function onPrev() {
        var prevRuleUuid = getPreviousRuleUuid();
        if (prevRuleUuid) setSelectedRuleUuid(prevRuleUuid);
      },
      onNext: function onNext() {
        var nextRuleUuid = getNextRuleUuid();
        if (nextRuleUuid) setSelectedRuleUuid(nextRuleUuid);
      },
      hasPrev: !!getPreviousRuleUuid(),
      hasNext: !!getNextRuleUuid(),
      onApplyAll: handleToggleResponded,
      onConcede: handleToggleConceded,
      isResponded: !!isRuleResponded,
      isConceded: !!isRuleConceded,
      isApplyDisabled: isApplyingAll,
      isConcedePending: isConceding
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_dialog.Dialog, {
      open: showFeedback,
      onOpenChange: setShowFeedback,
      "data-sentry-element": "Dialog",
      "data-sentry-source-file": "RuleDetailsPage.tsx",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_dialog.DialogContent, {
        "aria-describedby": undefined,
        onInteractOutside: function onInteractOutside(event) {
          return event.preventDefault();
        },
        "data-sentry-element": "DialogContent",
        "data-sentry-source-file": "RuleDetailsPage.tsx",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FeedbackForm.default, {
          item: feedbackItem,
          onDelete: removeFeedback,
          onSubmit: submitFeedback,
          "data-sentry-element": "FeedbackForm",
          "data-sentry-source-file": "RuleDetailsPage.tsx"
        })
      })
    })]
  });
};
var _default = exports.default = RuleDetailsPage;